// Libellés de navigation. Ajouter un fichier en.js avec les mêmes clés pour la version anglaise.
export const LOCALE = "fr-CA";

export const NAV_MAIN = [
  { to: "/", label: "Accueil", testid: "nav-accueil" },
  { to: "/travailleurs-non-incorpores", label: "Plans pour les travailleurs non incorporés", testid: "nav-non-incorpores" },
  { to: "/incorpores", label: "Plans pour les incorporés", testid: "nav-incorpores" },
  { to: "/plan-collectif", label: "Plan collectif", testid: "nav-collectif" },
  { to: "/plans-educatifs", label: "Plans éducatifs", testid: "nav-educatifs" },
];

export const NAV_EXTRA = [
  { to: "/pourquoi-struktiv", label: "Pourquoi STRUKTIV?", testid: "nav-pourquoi" },
  { to: "/forfaits", label: "Nos solutions", testid: "nav-solutions" },
  { to: "/ressources-faq", label: "Ressources et FAQ", testid: "nav-faq" },
  { to: "/consultation", label: "Prendre rendez-vous", testid: "nav-rendez-vous" },
  { to: "/consultation#contact", label: "Nous contacter", testid: "nav-contact" },
];

export const CONTACT_EMAIL = "finco@struktiv.info";
